import React, { useState } from 'react';
import { Divisor, Heading, Icon } from 'components';

import { useRouterStore } from 'apps/hooks';
import { useContextManager } from 'apps/context/hooks';

import { themes } from 'styles/themes/wikifactoryNew';
import { renameRevisionToVersion } from 'utils';
import RevisionItem from '../RevisionItem';
import {
  ChatDropdownButtonStyled,
  RevisionsWrapperStyled,
  ChatRevisionsStyled,
} from './chatRevision.styled';

interface Revision {
  title: string;
  version: string;
  dateCreated: Date;
  creator: {
    username: string;
  };
}

// interface ChatRevisionsProps {}

const ChatRevisions = () => {
  const [isRevisionVisible, setRevisionVisible] = useState(false);
  const contextManager = useContextManager();
  const routerStore = useRouterStore();

  const { revisions } = contextManager;
  if (!revisions) return null;

  const handleChatButtonClick = () => {
    setRevisionVisible(prevState => !prevState);
  };

  const handleRevisionClick = (revision: Revision) => () => {
    routerStore.navigate(routerStore.route.name, {
      ...routerStore.route.params,
      v: revision.version,
    });
    setRevisionVisible(false);
  };

  const { selectedRevision } = contextManager.contextAppHolder;

  return (
    <ChatRevisionsStyled
      style={{ top: 14, background: 'transparent' }}
      isOpen={isRevisionVisible}
    >
      <Divisor
        sx={{
          top: 12,
          width: '100%',
          position: 'absolute',
          borderColor: themes.color.wfGrey100,
          background: 'transparent',
        }}
      />
      <ChatDropdownButtonStyled onClick={handleChatButtonClick}>
        <Heading level='6' weight='xbold' size='xsmall'>
          {isRevisionVisible
            ? 'Versions'
            : renameRevisionToVersion(selectedRevision?.title || '')}
        </Heading>
        <Icon name={isRevisionVisible ? 'caret_up' : 'caret_down'} />
      </ChatDropdownButtonStyled>
      {isRevisionVisible ? (
        <RevisionsWrapperStyled>
          {revisions.map((revision: Revision) => {
            const selected = revision.version === selectedRevision.version;

            return (
              <RevisionItem
                key={revision.title}
                title={renameRevisionToVersion(revision.title)}
                selected={selected}
                date={revision.dateCreated}
                userName={revision.creator.username}
                onClick={handleRevisionClick(revision)}
              />
            );
          })}
        </RevisionsWrapperStyled>
      ) : null}
    </ChatRevisionsStyled>
  );
};

export default ChatRevisions;
